<template>
    <ItemIndex
        :singular-name="singularName"
        :plural-name="pluralName"
        :item-type="indexType"
    >
        <v-data-table
            :search="searchTerm"
            :headers="headers"
            :items="items"
            :items-per-page="10"
            :loading="tableLoading"
        >
            <ItemIndexFilterNotification
                :show="filter.show"
                :type="filter.type"
                :term="filter.term"
            />
            <template #item.name="{ item }">
                <v-btn
                    x-small
                    :to="'/font-pairing/edit/' + item.id"
                    color="primary"
                >
                    {{ item.name }}
                    <v-icon
                        right
                        x-small
                    >
                        fas fa-edit
                    </v-icon>
                </v-btn>
            </template>

            <template #item.font_1="{ item }">
                {{ item.pairing.h1.family }}
            </template>
            <template #item.font_2="{ item }">
                {{ item.pairing.body.family }}
            </template>

            <template #item.published="{ item }">
                <v-icon
                    small
                    color="primary"
                    v-if="item.published === 1"
                >
                    fas fa-check-circle
                </v-icon>
                <v-icon
                    small
                    color="error"
                    v-else
                >
                    fas fa-minus-circle
                </v-icon>
            </template>
        </v-data-table>
    </ItemIndex>
</template>

<script>
import ItemIndexBoilerplate from '@/views/Admin/Config/Commonn/ItemIndexBoilerplate';

export default {
    mixins: [ ItemIndexBoilerplate ],
    data() {
        return {
            indexType: 'font-pairing',
            singularName: 'Font Pairing',
            pluralName: 'Font Pairings',
            responseObject: 'pairings',
            headers: [
                {
                    text: 'Name',
                    value: 'name',
                },
                {
                    text: 'Heading 1',
                    value: 'font_1',
                    sortable: false,
                    filterable: false,
                },
                {
                    text: 'Body',
                    value: 'font_2',
                    sortable: false,
                    filterable: false,
                },
                {
                    text: 'Order',
                    value: 'order',
                },
                {
                    text: 'Published',
                    value: 'published',
                    align: 'right',
                }
            ],
        };
    }
};
</script>
